<template>
  <div class="select-sea-house">
    <el-dialog
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="title"
      width="30%"
      :close-on-click-modal="false"
      class="app-main-inner"
    >
      <div style="padding-bottom:5px">
        <el-button type="primary" @click="showTipDialog">{{ $t('CargoMsg.Cargo_Select') }}</el-button>
      </div>
      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :row-selection="rowSelection"
        style="width:100%;height:500px"
        @gridReady="gridReady"
      />
    </el-dialog>
    <!-- 海管家注意事项 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('SeaExport.MattersNeedingAttention')"
      class="sea-house-dialog"
    >
      <div class="dialog-txt">
        <h6><i class="el-icon-warning icon-tip" />{{ $t('queryJob.NewExportClearancePolicy') }}</h6>
        <p>{{ $t('queryJob.NewExportClearancePolicyTip') }}</p>
        <ul>
          <li>{{ $t('queryJob.YangshanAreaNovember152021') }}</li>
          <li>{{ $t('queryJob.WaigaoqiaoAreaNovember222021') }}</li>
        </ul>

        <h6><i class="el-icon-warning icon-tip" />{{ $t('queryJob.GarbageManifest') }}</h6>
        <p>{{ $t('queryJob.N1OnceTheManifestManifest') }}</p>
        <p>{{ $t('queryJob.N2ManifestMustBeDeletion') }}</p>
        <p>{{ $t('queryJob.N3YuanOnTheManifest') }}</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-checkbox v-model="notRemindNextTime" @change="hanldeRemindNext">{{ $t('SeaExport.DontRemindMeAgain') }}</el-checkbox>
        <el-button type="primary" @click="handleSeaHouse">{{ $t('Message.ConfirmSending') }}</el-button>
        <el-button @click="dialogVisible = false">{{ $t('Message.ReturnToModify') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sendSeaHousekeeper, updateSeaHousekeeper, deleteSeaHousekeeper } from '@/api/seaExport/manifestInfo'

export default {
  name: 'PreShippingBillDialog',
  props: {
    action: { type: String, default: 'send' },
    visible: { type: Boolean, required: true },
    title: { type: String, required: true },
    manifestInfo: { type: Object, default: () => {} }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        },
        onRowClicked: this.rowClick
      },
      columnDefs: [
        {
          headerName: this.$t('Message.ChannelName'),
          field: 'templateDescribe',
          suppressMenu: true,
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Note'),
          field: 'remark',
          suppressMenu: true,
          width: 100
        }
        // {
        //   headerName: this.$t('CargoMsg.Cargo_Parter'),
        //   field: '',
        //   suppressMenu: true,
        //   width: 100
        // },
        // {
        //   headerName: this.$t('CargoMsg.Cargo_Remarks'),
        //   field: '',
        //   suppressMenu: true,
        //   width: 110
        // }
      ],
      rowSelection: null,
      rowData: [],
      gridApi: null,
      dialogVisible: false,
      notRemindNextTime: false
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      } else {
        this.gridOptions.api.deselectAll()
        this.gridOptions.api.clearFocusedCell()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    this.rowSelection = 'single'
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    gridReady(param) {
      this.gridApi = param.api
      this.gridApi.sizeColumnsToFit()
    },
    toQuery() {
      this.rowData.push({
        templateDescribe: this.$t('SeaExport.SeaHousekeeper'),
        remark: '',
        manifestInfo: this.manifestInfo
      })
    },
    rowClick() {
      this.gridOptions.api.selectAll()
    },
    // 海管家注意事项
    showTipDialog() {
      if (this.action === 'send') {
        if (sessionStorage.getItem('remindNextTime')) {
          this.handleSeaHouse()
        } else {
          this.dialogVisible = true
        }
      } else if (this.action === 'update') {
        this.handleUpdate()
      } else if (this.action === 'delete') {
        this.handleDetele()
      }
    },
    // 海管家舱单发送
    handleSeaHouse() {
      const row = this.gridOptions.api.getSelectedRows()
      if (row.length > 0) {
        const param = {
          uuid: row[0].manifestInfo.uuid
        }
        sendSeaHousekeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.SendingSucceeded'))
            // 询问是否继续发送VGM
            this.$emit('prePlanBookingToVgm', row[0].manifestInfo)
            this.$emit('reload')
          }
        }).catch(err => {
          console.log(err)
        })
        this.dialogVisible = false
        this.innerVisible = false
      } else {
        this.$message.info(this.$t('Message.PleaseSelectASendingChannel'))
      }
    },
    handleUpdate() {
      const row = this.gridOptions.api.getSelectedRows()
      if (row.length > 0) {
        const param = {
          uuid: row[0].manifestInfo.uuid
        }
        updateSeaHousekeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.UpdateSucceeded'))
            this.$emit('reload')
          }
        })
        this.dialogVisible = false
        this.innerVisible = false
      }
    },
    handleDetele() {
      const row = this.gridOptions.api.getSelectedRows()
      if (row.length > 0) {
        const param = {
          uuid: row[0].manifestInfo.uuid
        }
        deleteSeaHousekeeper(param).then(res => {
          if (res.code === '0') {
            this.$message.success(this.$t('SeaExport.DeleteSucceeded'))
            this.$emit('reload')
          }
        })
        this.dialogVisible = false
        this.innerVisible = false
      }
    },
    // 海管家注意事项不再提醒复选框事件
    hanldeRemindNext() {
      sessionStorage.setItem('remindNextTime', this.notRemindNextTime)
    }
  }
}
</script>

<style lang="scss" scoped>
.select-sea-house{
  .sea-house-dialog{
    .dialog-txt{
      padding: 0 20px 10px 20px;
      h6{
        line-height: 20px;
        margin: 20px 0 10px 0;
        color: #333;
        font-size: 16px;
        font-weight: normal;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        i{
          margin-right: 8px;
          color: orange;
          font-size: 20px;
        }
      }
      p{
        margin: 5px 0;
        line-height: 20px;
        padding-left: 25px;
        color: #666;
        font-size: 14px;
      }
      ul{
        margin: 0;
        li{
          color: #666;
          line-height: 20px;
          font-size: 14px;
          list-style: disc;
          &::marker{
            font-size: 20px;
          }
        }
      }
    }
    .el-checkbox{
      margin-right: 20px;
    }
    .el-button{
      margin: 0 8px;
    }
  }
}
</style>
